import { makeAutoObservable, observable } from 'mobx';
import _ from 'lodash';
import { UserType } from '../types/user.type';
import { StorageEnum } from '../enums/storage.enum';
import { getMasterUser, getUser } from './utils';
import { RootStore } from './root.store';

export class UserStore {
  user: UserType | null = null;
  masterUser: UserType | null = null; // il folosim pentru momentele in care facem autentificare pe un alt cont de user (de exemplu de pe un cont de admin pe un cont de primarie)

  private _rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    makeAutoObservable(this, {
      user: observable.ref,
      masterUser: observable.ref
    });

    /** fetch the user from local storage, if any present */
    this.user = getUser(); // from local storage
    this.masterUser = getMasterUser();
  }

  setUser(newUserValue: UserType): void {
    this.user = newUserValue;
    this.masterUser = null;
    localStorage.setItem(StorageEnum.UserData, JSON.stringify(this.user));
    localStorage.removeItem(StorageEnum.MasterUserData);
  }

  logOutUser(): void {
    this.user = null;
    this.masterUser = null;
    localStorage.removeItem(StorageEnum.UserData);
    localStorage.removeItem(StorageEnum.MasterUserData);
    localStorage.clear(); // sterg tot ce e pe localStorage
  }

  setMasterUser(newUserValue: UserType): void {
    this.masterUser = _.cloneDeep(this.user);
    this.user = newUserValue;
    localStorage.setItem(StorageEnum.UserData, JSON.stringify(this.user));
    localStorage.setItem(
      StorageEnum.MasterUserData,
      JSON.stringify(this.masterUser)
    );
  }

  clearMasterUser(): void {
    if (this.masterUser) this.setUser(this.masterUser);
  }
}
